```vue
<template>
  <v-app>
    <div class="esport-page">
      <header class="navbar">
        <div class="navbar-inner">
          <div class="logo-section">
            <div class="logo-wrapper">
              <img src="/images/icon2.png" alt="logo" class="logo" />
            </div>

            <div>
              <h2>Diskominfo E-Sport</h2>
              <p>Bondowoso Berkah</p>
            </div>
          </div>

        </div>
      </header>

      <main class="esport-container">
        <div class="tab-navigation">
          <button class="tab-button" :class="{ active: tab === 0 }" @click="tab = 0">
            <span class="tab-icon">
              <v-icon small>mdi-gamepad-variant</v-icon>
            </span>
            <span>
              <strong>Pendaftaran</strong>
              <small>Daftar kompetisi</small>
            </span>
          </button>

          </button>
        </div>

        <div v-if="tab === 0">
          <v-card class="modern-card registration-card">
            <div class="card-header">
              <div>
                <div class="eyebrow">
                  <v-icon small>mdi-trophy-outline</v-icon>
                  E-SPORT COMPETITION
                </div>

                <h1 class="form-title">Pendaftaran Diskominfo E-Sport Competition</h1>

                <p class="form-desc">
                  Selamat datang di formulir pendaftaran
                  <strong>Diskominfo E-Sport Competition</strong>. Kompetisi ini bertujuan
                  untuk meningkatkan minat dan bakat di bidang e-sport di Kabupaten
                  Bondowoso.
                </p>
              </div>

              <div class="trophy-icon">
                <v-icon>mdi-trophy</v-icon>
              </div>
            </div>

            <div class="syarat-box">
              <div class="syarat-title">
                <span class="syarat-icon">
                  <v-icon small>mdi-information-outline</v-icon>
                </span>
                <strong>Syarat & Ketentuan</strong>
              </div>

              <ol>
                <li>
                  Satu orang maksimal bisa ikut <strong>5 Slot</strong> (khusus Pro
                  Evolution Soccer).
                </li>

                <li>
                  Pendaftaran dibuka untuk umum dengan biaya pendaftaran
                  <strong>Rp25.000,-/Slot</strong> (khusus Pro Evolution Soccer).
                </li>

                <li>
                  Wajib mendownload dan menginstall aplikasi
                  <a
                    href="https://play.google.com/store/apps/details?id=com.kominfo.bondowosoberkah"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link-berkah"
                    ><strong>Bondowoso Berkah</strong></a
                  >.
                </li>

                <li v-if="statusAI.batas_akhir_pendaftaran">
                  <strong>Lomba AI</strong>
                  Pengumpulan karya paling lambat
                  <strong>{{ formatTanggal(statusAI.batas_akhir_pendaftaran) }}</strong
                  >.
                </li>

                <li v-if="statusPES.tanggal_acara_mulai">
                  <strong>Lomba Pro Evolution Soccer</strong> — Acara dilaksanakan tanggal
                  <strong
                    >{{ formatTanggal(statusPES.tanggal_acara_mulai) }} -
                    {{ formatTanggal(statusPES.tanggal_acara_selesai) }}</strong
                  >. Pendaftaran ditutup paling lambat
                  <strong>{{ formatTanggal(statusPES.batas_akhir_pendaftaran) }}</strong
                  >.
                </li>

                <li v-if="dokumenAI.length" class="dokumen-box">
                  <div class="syarat-title">
                    <span class="syarat-icon"><v-icon small>mdi-creation</v-icon></span>
                    <strong>Download Dokumen — Lomba AI</strong>
                  </div>

                  <div class="dokumen-list">
                    <button
                      v-for="doc in dokumenAI"
                      :key="'dok-ai-' + doc.id"
                      type="button"
                      class="dokumen-item"
                      @click="openDokumen(doc)"
                    >
                      <v-icon small>mdi-file-document</v-icon>
                      <span>{{ doc.judul }}</span>
                      <v-icon small class="dokumen-download-icon">mdi-eye-outline</v-icon>
                    </button>
                  </div>
                </li>

                <li v-if="dokumenPES.length" class="dokumen-box">
                  <div class="syarat-title">
                    <span class="syarat-icon"><v-icon small>mdi-soccer</v-icon></span>
                    <strong>Download Dokumen — Pro Evolution Soccer</strong>
                  </div>

                  <div class="dokumen-list">
                    <button
                      v-for="doc in dokumenPES"
                      :key="'dok-pes-' + doc.id"
                      type="button"
                      class="dokumen-item"
                      @click="openDokumen(doc)"
                    >
                      <v-icon small>mdi-file-document</v-icon>
                      <span>{{ doc.judul }}</span>
                      <v-icon small class="dokumen-download-icon">mdi-eye-outline</v-icon>
                    </button>
                  </div>
                </li>

                <li v-if="medsosList.length" class="medsos-box">
                  <strong>Kunjungi medsos kami untuk info lebih lanjut:</strong>
                  <a
                    v-for="ms in medsosList"
                    :key="ms.id"
                    :href="ms.url_medsos"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="medsos-item"
                  >
                    <v-icon small>{{ ms.icon || "mdi-link-variant" }}</v-icon>
                    <span>{{ ms.nama_platform }}</span>
                  </a>
                </li>
              </ol>
            </div>

            <v-alert
              v-if="!checkingStatus && form.jenis_lomba && !isOpen"
              type="warning"
              border="left"
              class="modern-alert alert-warning-custom"
            >
              <div class="alert-content">
                <v-icon class="alert-icon" small>mdi-alert-circle-outline</v-icon>
                <span>{{ closeMsg || "Pendaftaran saat ini sedang ditutup." }}</span>
              </div>
            </v-alert>

            <v-alert
              v-if="successMsg"
              type="success"
              border="left"
              class="modern-alert alert-success-custom"
            >
              <div class="alert-content">
                <v-icon class="alert-icon" small> mdi-check-circle-outline </v-icon>

                <span>{{ successMsg }}</span>

                <v-btn
                  icon
                  x-small
                  type="button"
                  class="alert-close"
                  @click="successMsg = ''"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-alert>

            <v-alert
              v-if="errorMsg"
              type="error"
              border="left"
              class="modern-alert alert-error-custom"
            >
              <div class="alert-content">
                <v-icon class="alert-icon" small> mdi-alert-circle-outline </v-icon>

                <span>{{ errorMsg }}</span>

                <v-btn
                  icon
                  x-small
                  type="button"
                  class="alert-close"
                  @click="errorMsg = ''"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-alert>

            <v-form ref="formRef" @submit.prevent="submitPendaftaran">
              <div class="form-grid">
                <div class="form-field-full">
                  <v-text-field
                    v-model="form.email"
                    label="Email *"
                    type="email"
                    outlined
                    dense
                    prepend-inner-icon="mdi-email-outline"
                    :disabled="!isOpen"
                    :rules="[(v) => !!v || 'Email wajib diisi']"
                  />
                </div>

                <div class="form-field-full">
                  <div class="field-label">Pilih Jenis Lomba *</div>

                  <div class="competition-options">
                    <div
                      class="competition-option"
                      :class="{
                        selected: form.jenis_lomba === 'AI',
                      }"
                      @click="form.jenis_lomba = 'AI'"
                    >
                      <div class="competition-icon ai">
                        <v-icon>mdi-robot-outline</v-icon>
                      </div>

                      <div>
                        <strong>AI</strong>
                        <span>Artificial Intelligence</span>
                      </div>

                      <v-icon v-if="form.jenis_lomba === 'AI'" class="check-icon">
                        mdi-check-circle
                      </v-icon>
                    </div>

                    <div
                      class="competition-option"
                      :class="{
                        selected: form.jenis_lomba === 'PRO EVOLUTION SOCCER',
                      }"
                      @click="form.jenis_lomba = 'PRO EVOLUTION SOCCER'"
                    >
                      <div class="competition-icon football">
                        <v-icon>mdi-soccer</v-icon>
                      </div>

                      <div>
                        <strong>Pro Evolution Soccer</strong>
                        <span>Kompetisi sepak bola</span>
                      </div>

                      <v-icon
                        v-if="form.jenis_lomba === 'PRO EVOLUTION SOCCER'"
                        class="check-icon"
                      >
                        mdi-check-circle
                      </v-icon>
                    </div>
                  </div>
                </div>

                <div>
                  <v-text-field
                    v-model="form.nama_lengkap"
                    label="Nama Lengkap *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-account-outline"
                    :disabled="!isOpen"
                    :rules="[(v) => !!v || 'Nama lengkap wajib diisi']"
                  />
                </div>

                <div>
                  <v-text-field
                    v-model="form.no_telp"
                    label="No Telp / WhatsApp *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-whatsapp"
                    :disabled="!isOpen"
                    :rules="[(v) => !!v || 'Nomor WA wajib diisi']"
                  />
                </div>
              </div>

              <div class="video-section" v-if="form.jenis_lomba === 'AI'">
                <div class="field-label">Link Video Google Drive (Hasil Karya AI) *</div>

                <v-text-field
                  v-model="form.link_video_ai"
                  label="Link Google Drive Video *"
                  placeholder="https://drive.google.com/file/d/xxxxxxxx/view"
                  outlined
                  dense
                  prepend-inner-icon="mdi-google-drive"
                  :disabled="!isOpen"
                  :rules="rulesLinkDrive"
                  hint="Pastikan file di-share dengan akses 'Siapa saja yang memiliki link'"
                  persistent-hint
                />
              </div>

              <div
                class="slot-section"
                v-if="form.jenis_lomba === 'PRO EVOLUTION SOCCER'"
              >
                <div class="field-label">Jumlah Slot</div>

                <div class="slot-options">
                  <button
                    v-for="n in 5"
                    :key="n"
                    type="button"
                    class="slot-button"
                    :class="{ selected: form.jumlah_slot === n }"
                    :disabled="!isOpen"
                    @click="form.jumlah_slot = n"
                  >
                    <strong>{{ n }}</strong>
                    <span>Slot</span>
                  </button>
                </div>
              </div>

              <template v-if="form.jenis_lomba === 'PRO EVOLUTION SOCCER'">
                <div class="payment-section">
                  <div class="payment-header">
                    <div class="payment-icon">
                      <v-icon> mdi-qrcode-scan </v-icon>
                    </div>

                    <div>
                      <strong> Pembayaran QRIS </strong>

                      <span> Scan QR berikut untuk melakukan pembayaran. </span>
                    </div>
                  </div>

                  <div v-if="qris" class="qris-content">
                    <img :src="qris.url_qris" alt="QRIS Pembayaran" class="qris-img" />

                    <div class="rekening-box">
                      <div class="rekening-title">
                        <v-icon small> mdi-bank-outline </v-icon>

                        <strong>Alternatif Pembayaran</strong>
                      </div>

                      <div class="rekening-item">
                        <div class="rekening-bank">
                          <span class="bank-badge bca"> BCA </span>

                          <div>
                            <strong>1200810437</strong>
                            <span>A/n Yudhistira Laksni Putra</span>
                          </div>
                        </div>

                        <v-btn
                          icon
                          x-small
                          type="button"
                          @click="copyRekening('1200810437')"
                        >
                          <v-icon small> mdi-content-copy </v-icon>
                        </v-btn>
                      </div>

                      <div class="rekening-divider"></div>

                      <div class="rekening-item">
                        <div class="rekening-bank">
                          <span class="bank-badge jatim"> BANK JATIM</span>

                          <div>
                            <strong>0318027621</strong>
                            <span>A/n Yudhistira Laksni Putra</span>
                          </div>
                        </div>

                        <v-btn
                          icon
                          x-small
                          type="button"
                          @click="copyRekening('0318027621')"
                        >
                          <v-icon small> mdi-content-copy </v-icon>
                        </v-btn>
                      </div>

                      <div class="rekening-note">
                        <v-icon x-small> mdi-information-outline </v-icon>

                        Silakan gunakan salah satu metode pembayaran di atas sesuai
                        kenyamanan Anda.
                      </div>
                    </div>
                  </div>

                  <div v-else class="qris-empty">
                    <v-icon> mdi-alert-circle-outline </v-icon>

                    <span>
                      QRIS pembayaran belum tersedia, silakan hubungi panitia.
                    </span>
                  </div>
                </div>

                <v-file-input
                  v-model="form.bukti_pembayaran"
                  label="Bukti Pembayaran *"
                  accept="image/*,application/pdf"
                  outlined
                  dense
                  prepend-icon="mdi-paperclip"
                  :disabled="!isOpen"
                  hint="Format gambar atau PDF"
                  persistent-hint
                />
              </template>

              <div id="g-recaptcha-esport" class="captcha-container"></div>

              <v-btn
                type="submit"
                block
                height="52"
                color="#018c74"
                class="submit-btn"
                :loading="submitting"
                :disabled="!form.jenis_lomba || !isOpen || !captchaVerified"
              >
                <v-icon left>mdi-send-outline</v-icon>
                {{
                  !form.jenis_lomba
                    ? "Pilih Jenis Lomba"
                    : !isOpen
                    ? "Pendaftaran Ditutup"
                    : captchaVerified
                    ? "Daftar Sekarang"
                    : "Verifikasi Captcha"
                }}
              </v-btn>
            </v-form>
          </v-card>
        </div>

        <div v-else>
          <div class="rekap-heading">
            <div>
              <div class="eyebrow">
                <v-icon small> mdi-chart-box-outline </v-icon>

                DATA PESERTA
              </div>

              <h1>Rekap Pendaftar</h1>

              <p>Daftar peserta yang telah melakukan pendaftaran kompetisi.</p>
            </div>

            <v-btn
              depressed
              class="refresh-btn"
              :loading="loadingRekap"
              @click="fetchRekap"
            >
              <v-icon left small> mdi-refresh </v-icon>

              Refresh
            </v-btn>
          </div>

          <div class="summary-grid">
            <div class="summary-card total">
              <div class="summary-icon">
                <v-icon> mdi-account-group </v-icon>
              </div>

              <div>
                <span>Total Pendaftar</span>
                <strong>
                  {{ rekap.length }}
                </strong>
              </div>
            </div>

            <div class="summary-card slot">
              <div class="summary-icon">
                <v-icon> mdi-ticket-confirmation-outline </v-icon>
              </div>

              <div>
                <span>Total Slot</span>
                <strong>
                  {{ totalSlot }}
                </strong>
              </div>
            </div>

            <div class="summary-card ai">
              <div class="summary-icon">
                <v-icon> mdi-robot-outline </v-icon>
              </div>

              <div>
                <span>Lomba AI</span>
                <strong>
                  {{ totalAI }}
                </strong>
              </div>
            </div>

            <div class="summary-card pes">
              <div class="summary-icon">
                <v-icon> mdi-soccer </v-icon>
              </div>

              <div>
                <span>Pro Evolution Soccer</span>
                <strong>
                  {{ totalPES }}
                </strong>
              </div>
            </div>
          </div>

          <v-card class="modern-card filter-card">
            <div class="filter-header">
              <div>
                <strong> Filter Peserta </strong>

                <span> Cari berdasarkan nama atau pilih jenis lomba. </span>
              </div>

              <v-btn text small class="reset-btn" @click="resetFilter">
                <v-icon left small> mdi-filter-remove-outline </v-icon>

                Reset
              </v-btn>
            </div>

            <div class="filter-grid">
              <v-text-field
                v-model="search"
                outlined
                dense
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
                label="Cari nama"
                class="search-field"
              />

              <div class="competition-filter">
                <button
                  class="filter-chip"
                  :class="{
                    active: filterJenis === 'ALL',
                  }"
                  @click="filterJenis = 'ALL'"
                >
                  Semua
                </button>

                <button
                  class="filter-chip ai-filter"
                  :class="{
                    active: filterJenis === 'AI',
                  }"
                  @click="filterJenis = 'AI'"
                >
                  <v-icon left x-small> mdi-robot-outline </v-icon>

                  AI
                </button>

                <button
                  class="filter-chip pes-filter"
                  :class="{
                    active: filterJenis === 'PRO EVOLUTION SOCCER',
                  }"
                  @click="filterJenis = 'PRO EVOLUTION SOCCER'"
                >
                  <v-icon left x-small> mdi-soccer </v-icon>

                  PES
                </button>
              </div>
            </div>

            <div class="filter-result">
              <span>
                Menampilkan
                <strong>
                  {{ filteredRekap.length }}
                </strong>
                pendaftar
              </span>

              <span v-if="search || filterJenis !== 'ALL'" class="filter-active">
                <v-icon x-small> mdi-filter-outline </v-icon>

                Filter aktif
              </span>
            </div>
          </v-card>

          <v-card class="modern-card table-card">
            <div class="table-title">
              <div>
                <strong> Daftar Peserta </strong>

                <span> Data pendaftaran kompetisi </span>
              </div>
            </div>

            <v-data-table
              :headers="headers"
              :items="filteredRekap"
              :loading="loadingRekap"
              class="modern-table"
              item-key="id"
              no-data-text="Tidak ada peserta yang sesuai"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-text': 'Data per halaman',
              }"
            >
              <template v-slot:item.nama_lengkap="{ item }">
                <div class="participant">
                  <div class="participant-avatar">
                    {{ getInitial(item.nama_lengkap) }}
                  </div>

                  <div>
                    <strong>
                      {{ item.nama_lengkap }}
                    </strong>

                    <span>
                      {{ item.email || "-" }}
                    </span>
                  </div>
                </div>
              </template>

              <template v-slot:item.jenis_lomba="{ item }">
                <div
                  class="competition-badge"
                  :class="item.jenis_lomba === 'AI' ? 'ai-badge' : 'pes-badge'"
                >
                  <v-icon small>
                    {{ item.jenis_lomba === "AI" ? "mdi-robot-outline" : "mdi-soccer" }}
                  </v-icon>

                  <span>
                    {{ item.jenis_lomba === "AI" ? "AI" : "PES" }}
                  </span>
                </div>
              </template>

              <template v-slot:item.no_telp="{ item }">
                <div class="phone-number">
                  <v-icon small> mdi-whatsapp </v-icon>

                  {{ item.no_telp }}
                </div>
              </template>

              <template v-slot:item.jumlah_slot="{ item }">
                <span
                  v-if="item.jenis_lomba === 'PRO EVOLUTION SOCCER'"
                  class="slot-badge"
                >
                  {{ item.jumlah_slot }} Slot
                </span>
                <span v-else class="bukti-na">—</span>
              </template>

              <template v-slot:item.status_verifikasi="{ item }">
                <span
                  class="status-badge"
                  :class="`status-${getStatusInfo(item.status_verifikasi).color}`"
                >
                  <v-icon x-small>{{
                    getStatusInfo(item.status_verifikasi).icon
                  }}</v-icon>
                  {{ getStatusInfo(item.status_verifikasi).label }}
                </span>
              </template>

              <template v-slot:item.created_at="{ item }">
                <div class="date-cell">
                  <strong>
                    {{ formatDateOnly(item.created_at) }}
                  </strong>

                  <span>
                    {{ formatTime(item.created_at) }}
                  </span>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </main>

      <v-dialog v-model="dokumenDialog" max-width="600">
        <v-card class="dokumen-dialog-card" v-if="selectedDokumen">
          <div class="dokumen-dialog-header">
            <div>
              <strong>{{ selectedDokumen.judul }}</strong>
              <span>{{
                selectedDokumen.jenis_dokumen === "JUKNIS"
                  ? "Petunjuk Teknis"
                  : "Petunjuk Pelaksanaan"
              }}</span>
            </div>

            <v-btn icon small @click="dokumenDialog = false">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>

          <div class="dokumen-dialog-body">
            <img
              v-if="dokumenIsImage(selectedDokumen)"
              :src="selectedDokumen.file_url"
              alt="Preview Dokumen"
              class="dokumen-full-img"
            />

            <iframe
              v-else-if="dokumenIsPdf(selectedDokumen)"
              :src="selectedDokumen.file_url"
              class="dokumen-pdf-frame"
            ></iframe>

            <div v-else class="dokumen-fallback">
              <v-icon large>mdi-file-outline</v-icon>
              <span>Preview tidak tersedia untuk tipe file ini.</span>
            </div>
          </div>

          <div class="dokumen-dialog-footer">
            <a
              :href="selectedDokumen.file_url"
              target="_blank"
              rel="noopener noreferrer"
              class="dokumen-open-link"
            >
              <v-icon small left>mdi-open-in-new</v-icon>
              Buka di tab baru
            </a>

            <a
              :href="selectedDokumen.file_url"
              :download="selectedDokumen.judul"
              class="dokumen-open-link primary"
            >
              <v-icon small left>mdi-download-outline</v-icon>
              Unduh
            </a>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from "vue";
import router from "@/router";
import axios from "axios";

const API_BASE = "https://berkah.bondowosokab.go.id:5500";

const API_KEY = "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97";

const authHeaders = {
  headers: {
    "Bondowoso-Berkah": API_KEY,
  },
};

const tab = ref(0);

const formRef = ref(null);
const submitting = ref(false);

const successMsg = ref("");
const errorMsg = ref("");

const qris = ref(null);
const captchaVerified = ref(false);

const statusAI = ref({
  is_open: true,
  pesan: "",
  tanggal_acara_mulai: null,
  tanggal_acara_selesai: null,
  batas_akhir_pendaftaran: null,
});

const statusAktif = computed(() => {
  if (form.value.jenis_lomba === "AI") return statusAI.value;
  if (form.value.jenis_lomba === "PRO EVOLUTION SOCCER") return statusPES.value;
  return null;
});

const isOpen = computed(() => {
  if (!statusAktif.value) return true;
  return statusAktif.value.is_open;
});

const closeMsg = computed(() => statusAktif.value?.pesan || "");

const statusPES = ref({
  is_open: true,
  pesan: "",
  tanggal_acara_mulai: null,
  tanggal_acara_selesai: null,
  batas_akhir_pendaftaran: null,
});

const checkingStatus = ref(true);

const form = ref({
  email: "",
  jenis_lomba: "",
  nama_lengkap: "",
  no_telp: "",
  jumlah_slot: 1,
  link_video_ai: "",
  bukti_pembayaran: null,
});

const rekap = ref([]);
const loadingRekap = ref(false);

const statusOptions = [
  { value: 0, label: "Menunggu", color: "warning", icon: "mdi-clock-outline" },
  { value: 1, label: "Diterima", color: "success", icon: "mdi-check-circle-outline" },
  { value: 2, label: "Ditolak", color: "error", icon: "mdi-close-circle-outline" },
];

const getStatusInfo = (status) => {
  return statusOptions.find((s) => s.value === Number(status)) || statusOptions[0];
};

const medsosList = ref([]);

const dokumenAI = ref([]);
const dokumenPES = ref([]);

const fetchDokumen = async () => {
  try {
    const { data } = await axios.get(`${API_BASE}/esport/dokumen`, authHeaders);
    const list = data?.response?.data || data?.data || [];

    dokumenAI.value = list.filter((d) => d.jenis_lomba === "AI");
    dokumenPES.value = list.filter((d) => d.jenis_lomba === "PRO EVOLUTION SOCCER");
  } catch (err) {
    console.error("Gagal memuat dokumen", err);
  }
};

const adaDokumenAI = computed(
  () => dokumenJuknisAI.value.length || dokumenJuklakAI.value.length
);
const adaDokumenPES = computed(
  () => dokumenJuknisPES.value.length || dokumenJuklakPES.value.length
);

const fetchMedsos = async () => {
  try {
    const { data } = await axios.get(`${API_BASE}/esport/medsos`, authHeaders);
    medsosList.value = data?.response?.data || data?.data || [];
  } catch (err) {
    console.error("Gagal memuat medsos", err);
  }
};

const dokumenDialog = ref(false);
const selectedDokumen = ref(null);

const dokumenIsImage = (doc) => {
  if (!doc?.file_url) return false;
  return /\.(png|jpe?g|webp|gif)$/i.test(doc.file_url);
};

const dokumenIsPdf = (doc) => {
  if (!doc?.file_url) return false;
  return /\.pdf$/i.test(doc.file_url);
};

const openDokumen = (doc) => {
  selectedDokumen.value = doc;
  dokumenDialog.value = true;
};

const rulesLinkDrive = [
  (v) => !!v || "Link video Google Drive wajib diisi",
  (v) =>
    /drive\.google\.com\/(file\/d\/|open\?id=|.*[?&]id=)/.test(v || "") ||
    "Link harus berupa link share Google Drive (mis. https://drive.google.com/file/d/.../view)",
];


const search = ref("");
const filterJenis = ref("ALL");

const filteredRekap = computed(() => {
  const keyword = search.value.toLowerCase().trim();

  return rekap.value.filter((item) => {
    const nama = String(item.nama_lengkap || "").toLowerCase();

    const noTelp = String(item.no_telp || "").toLowerCase();

    const email = String(item.email || "").toLowerCase();

    const cocokSearch =
      !keyword ||
      nama.includes(keyword) ||
      noTelp.includes(keyword) ||
      email.includes(keyword);

    const cocokJenis =
      filterJenis.value === "ALL" || item.jenis_lomba === filterJenis.value;

    return cocokSearch && cocokJenis;
  });
});


const totalSlot = computed(() => {
  return rekap.value
    .filter((item) => item.jenis_lomba === "PRO EVOLUTION SOCCER")
    .reduce((total, item) => total + Number(item.jumlah_slot || 0), 0);
});

const totalAI = computed(() => {
  return rekap.value.filter((item) => item.jenis_lomba === "AI").length;
});

const totalPES = computed(() => {
  return rekap.value.filter((item) => item.jenis_lomba === "PRO EVOLUTION SOCCER").length;
});


const headers = [
  { text: "Peserta", value: "nama_lengkap", width: "250px" },
  { text: "Jenis Lomba", value: "jenis_lomba", width: "170px" },
  { text: "No. WhatsApp", value: "no_telp", width: "160px" },
  { text: "Slot", value: "jumlah_slot", align: "center", width: "100px" },
  {
    text: "Status Verifikasi",
    value: "status_verifikasi",
    align: "center",
    width: "160px",
    sortable: false,
  },
  { text: "Tanggal Daftar", value: "created_at", width: "160px" },
];


const fetchStatusJenis = async (jenis) => {
  try {
    const { data } = await axios.get(`${API_BASE}/esport/pengaturan/status`, {
      ...authHeaders,
      params: { jenis_lomba: jenis },
    });
    const info = data?.response?.data || data?.data || {};
    return {
      is_open: !!info.is_open,
      pesan: info.pesan || "",
      tanggal_acara_mulai: info.tanggal_acara_mulai,
      tanggal_acara_selesai: info.tanggal_acara_selesai,
      batas_akhir_pendaftaran: info.batas_akhir_pendaftaran,
    };
  } catch (err) {
    console.error(`Gagal memuat status pendaftaran ${jenis}`, err);
    return {
      is_open: true,
      pesan: "",
      tanggal_acara_mulai: null,
      tanggal_acara_selesai: null,
      batas_akhir_pendaftaran: null,
    };
  }
};

const fetchSemuaStatus = async () => {
  checkingStatus.value = true;
  const [ai, pes] = await Promise.all([
    fetchStatusJenis("AI"),
    fetchStatusJenis("PRO EVOLUTION SOCCER"),
  ]);
  statusAI.value = ai;
  statusPES.value = pes;
  checkingStatus.value = false;
};

watch(tab, (val) => {
  if (val === 1) {
    fetchRekap();
  }
  if (val === 0) {
    captchaVerified.value = false;
    captchaWidgetId.value = null;
    nextTick(() => initCaptcha());
  }
});

const fetchQris = async () => {
  try {
    const { data } = await axios.get(`${API_BASE}/esport/qris`, authHeaders);

    const list = data?.response?.data || data?.data || [];

    qris.value = list.length > 0 ? list[0] : null;
  } catch (err) {
    console.error("Gagal memuat QRIS", err);
  }
};


const fetchRekap = async () => {
  loadingRekap.value = true;

  try {
    const { data } = await axios.get(`${API_BASE}/esport/pendaftar`, authHeaders);

    rekap.value = data?.response?.data || data?.data || [];
  } catch (err) {
    console.error("Gagal memuat rekap pendaftar", err);
  } finally {
    loadingRekap.value = false;
  }
};

const captchaWidgetId = ref(null);

const initCaptcha = () => {
  const checkGrecaptcha = setInterval(() => {
    if (typeof window.grecaptcha !== "undefined" && window.grecaptcha.render) {
      clearInterval(checkGrecaptcha);

      captchaWidgetId.value = window.grecaptcha.render("g-recaptcha-esport", {
        sitekey: "6Lepj1IsAAAAAB-2w3plY3b8KDry863j0x0yXwSb",
        theme: "light",
        callback: () => {
          captchaVerified.value = true;
        },
        "expired-callback": () => {
          captchaVerified.value = false;
        },
      });
    }
  }, 500);
};

const resetCaptcha = () => {
  if (typeof window.grecaptcha !== "undefined" && captchaWidgetId.value !== null) {
    window.grecaptcha.reset(captchaWidgetId.value);
  }
  captchaVerified.value = false;
};


const resetFilter = () => {
  search.value = "";
  filterJenis.value = "ALL";
};


const resetForm = () => {
  form.value = {
    email: "",
    jenis_lomba: "",
    nama_lengkap: "",
    no_telp: "",
    jumlah_slot: 1,
    link_video_ai: "",
    bukti_pembayaran: null,
  };
  formRef.value?.resetValidation();
};

const validateForm = async () => {
  const result = formRef.value.validate();

  if (typeof result === "boolean") {
    return result;
  }

  const awaited = await result;

  return awaited?.valid ?? awaited;
};

const submitPendaftaran = async () => {
  errorMsg.value = "";
  successMsg.value = "";

  if (!isOpen.value) {
    errorMsg.value = closeMsg.value || "Pendaftaran sudah ditutup.";
    return;
  }

  if (!captchaVerified.value) {
    errorMsg.value = "Silakan verifikasi captcha terlebih dahulu.";
    return;
  }

  const valid = await validateForm();
  if (!valid) return;

  if (form.value.jenis_lomba === "PRO EVOLUTION SOCCER" && !form.value.bukti_pembayaran) {
    errorMsg.value = "Bukti pembayaran wajib diupload untuk lomba Pro Evolution Soccer.";
    return;
  }

  submitting.value = true;

  if (form.value.jenis_lomba === "AI" && !form.value.link_video_ai) {
    errorMsg.value = "Link video Google Drive wajib diisi untuk lomba AI.";
    return;
  }

  try {
    const fd = new FormData();
    fd.append("email", form.value.email);
    fd.append("jenis_lomba", form.value.jenis_lomba);
    fd.append("nama_lengkap", form.value.nama_lengkap);
    fd.append("no_telp", form.value.no_telp);

    if (form.value.jenis_lomba === "PRO EVOLUTION SOCCER") {
      fd.append("jumlah_slot", form.value.jumlah_slot);
    }

    if (form.value.jenis_lomba === "AI") {
      fd.append("link_video_ai", form.value.link_video_ai);
    }

    if (form.value.bukti_pembayaran) {
      const file = Array.isArray(form.value.bukti_pembayaran)
        ? form.value.bukti_pembayaran[0]
        : form.value.bukti_pembayaran;
      fd.append("bukti_pembayaran", file);
    }

    await axios.post(`${API_BASE}/esport/pendaftar`, fd, {
      headers: {
        "Bondowoso-Berkah": API_KEY,
        "Content-Type": "multipart/form-data",
      },
    });

    successMsg.value = "Pendaftaran berhasil dikirim. Terima kasih!";
    resetForm();
    fetchRekap();
  } catch (err) {
    const resData = err.response?.data;
    errorMsg.value =
      resData?.metadata?.message || "Gagal mengirim pendaftaran, coba lagi.";

    if (err.response?.status === 403) {
      fetchSemuaStatus();
    }
  } finally {
    submitting.value = false;
    resetCaptcha();
  }
};


const copyRekening = async (nomor) => {
  try {
    await navigator.clipboard.writeText(nomor);
    successMsg.value = `Nomor rekening ${nomor} berhasil disalin.`;
  } catch (err) {
    console.error("Gagal menyalin nomor rekening", err);

    const textarea = document.createElement("textarea");
    textarea.value = nomor;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand("copy");
      successMsg.value = `Nomor rekening ${nomor} berhasil disalin.`;
    } catch (fallbackErr) {
      errorMsg.value = "Gagal menyalin nomor rekening.";
    }

    document.body.removeChild(textarea);
  }
};

const formatTanggal = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return new Intl.DateTimeFormat("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

const formatDateOnly = (dateString) => {
  if (!dateString) return "-";

  return new Intl.DateTimeFormat("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(dateString));
};

const formatTime = (dateString) => {
  if (!dateString) return "";

  return new Intl.DateTimeFormat("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(dateString));
};

const getInitial = (name) => {
  if (!name) return "?";

  return name.trim().charAt(0).toUpperCase();
};

watch(
  () => form.value.jenis_lomba,
  (jenis) => {
    if (jenis === "AI") {
      form.value.jumlah_slot = null;
    } else if (jenis === "PRO EVOLUTION SOCCER") {
      if (!form.value.jumlah_slot) form.value.jumlah_slot = 1;
      form.value.link_video_ai = "";
    }
  }
);

onMounted(() => {
  fetchSemuaStatus();
  fetchQris();
  fetchDokumen();
  fetchMedsos();
  initCaptcha();
});
</script>

<style scoped>

.esport-page {
  min-height: 100vh;
  background: radial-gradient(
      circle at top right,
      rgba(1, 140, 116, 0.08),
      transparent 35%
    ),
    linear-gradient(
      135deg,
      rgba(245, 251, 250, 0.3) 0%,
      rgba(238, 251, 247, 0.3) 50%,
      rgba(248, 250, 252, 0.3) 100%
    ),
    url("/images/esports.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  padding-bottom: 60px;
  color: #182433;

  font-family: "Inter", "Roboto", sans-serif;
}

.navbar {
  position: sticky;
  top: 0;
  z-index: 20;

  background: rgba(255, 255, 255, 0.82);

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.navbar-inner {
  max-width: 1180px;
  margin: auto;
  padding: 14px 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-wrapper {
  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #ffffff;
  border-radius: 13px;

  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.08);
}

.logo {
  width: 34px;
  height: 34px;
}

.logo-section h2 {
  margin: 0;

  font-size: 16px;
  font-weight: 800;

  color: #182433;
}

.logo-section p {
  margin: 2px 0 0;

  font-size: 11px;
  color: #64748b;
}

.back-btn {
  border-radius: 10px !important;
  color: #475569 !important;
}


.esport-container {
  max-width: 1180px;
  margin: 28px auto;
  padding: 0 20px;
}


.tab-navigation {
  display: grid;
  grid-template-columns: 1fr 1fr;

  gap: 6px;

  padding: 6px;

  background: rgba(255, 255, 255, 0.8);

  border: 1px solid rgba(15, 23, 42, 0.06);

  border-radius: 17px;

  margin-bottom: 22px;

  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.05);
}

.tab-button {
  border: 0;
  background: transparent;

  border-radius: 12px;

  padding: 10px 16px;

  display: flex;
  align-items: center;

  gap: 10px;

  text-align: left;

  cursor: pointer;

  color: #64748b;

  transition: 0.2s ease;
}

.tab-button:hover {
  background: #f1f5f9;
}

.tab-button.active {
  background: #ffffff;

  color: #018c74;

  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
}

.tab-button strong {
  display: block;

  font-size: 13px;
}

.tab-button small {
  display: block;

  margin-top: 1px;

  font-size: 10px;

  color: #94a3b8;
}

.tab-icon {
  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background: #f1f5f9;
}

.tab-button.active .tab-icon {
  background: rgba(1, 140, 116, 0.1);
}


.modern-card {
  background: rgba(255, 255, 255, 0.92) !important;

  border: 1px solid rgba(15, 23, 42, 0.06) !important;

  border-radius: 22px !important;

  box-shadow: 0 15px 45px rgba(15, 23, 42, 0.06) !important;
}


.registration-card {
  padding: 30px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  gap: 20px;

  margin-bottom: 24px;
}

.eyebrow {
  display: flex;
  align-items: center;

  gap: 5px;

  font-size: 10px;
  font-weight: 800;

  letter-spacing: 1px;

  color: #018c74;

  margin-bottom: 8px;
}

.form-title {
  font-size: 27px;
  line-height: 1.25;

  font-weight: 800;

  margin: 0 0 8px;

  color: #182433;
}

.form-desc {
  max-width: 780px;

  font-size: 14px;
  line-height: 1.7;

  color: #64748b;

  margin: 0;
}

.trophy-icon {
  flex: 0 0 60px;

  width: 60px;
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 18px;

  background: rgba(1, 140, 116, 0.1);

  color: #018c74;
}

.trophy-icon .v-icon {
  font-size: 30px;
}


.syarat-box {
  background: #f4fbf9;

  border: 1px solid rgba(1, 140, 116, 0.12);

  border-radius: 16px;

  padding: 18px 20px;

  margin-bottom: 24px;
}

.syarat-title {
  display: flex;
  align-items: center;

  gap: 9px;

  color: #018c74;

  font-size: 14px;

  margin-bottom: 10px;
}

.syarat-icon {
  width: 28px;
  height: 28px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(1, 140, 116, 0.1);

  border-radius: 8px;
}

.syarat-box ol {
  margin: 0;

  padding-left: 20px;

  color: #64748b;

  font-size: 13px;

  line-height: 1.8;
}

.syarat-box .link-berkah {
  color: #018c74;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 700;
}

.syarat-box .link-berkah:hover {
  color: #016a5b;
}

.form-grid {
  display: grid;

  grid-template-columns: 1fr 1fr;

  gap: 8px 18px;
}

.form-field-full {
  grid-column: span 2;
}

.field-label {
  font-size: 13px;

  font-weight: 700;

  color: #334155;

  margin-bottom: 8px;
}


.competition-options {
  display: grid;

  grid-template-columns: 1fr 1fr;

  gap: 12px;

  margin-bottom: 12px;
}

.competition-option {
  position: relative;

  display: flex;
  align-items: center;

  gap: 12px;

  padding: 14px;

  border: 1px solid #e2e8f0;

  border-radius: 14px;

  cursor: pointer;

  transition: 0.2s ease;

  background: #ffffff;
}

.competition-option:hover {
  border-color: #94d5c8;

  transform: translateY(-1px);
}

.competition-option.selected {
  border-color: #018c74;

  background: rgba(1, 140, 116, 0.04);

  box-shadow: 0 5px 16px rgba(1, 140, 116, 0.08);
}

.competition-option strong {
  display: block;

  font-size: 13px;

  color: #1e293b;
}

.competition-option span {
  display: block;

  font-size: 10px;

  margin-top: 2px;

  color: #94a3b8;
}

.competition-icon {
  width: 42px;
  height: 42px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;
}

.competition-icon.ai {
  background: #eff6ff;
  color: #3b82f6;
}

.competition-icon.football {
  background: #ecfdf5;
  color: #018c74;
}

.check-icon {
  position: absolute;

  top: 10px;
  right: 10px;

  color: #018c74;
}


.slot-section {
  margin: 8px 0 18px;
}

.slot-options {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.slot-button {
  flex: 1 1 auto;
  min-width: 56px;
  padding: 9px 6px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  transition: 0.2s;
}

.slot-button strong {
  display: block;

  font-size: 18px;

  color: #334155;
}

.slot-button span {
  display: block;

  font-size: 10px;

  color: #94a3b8;
}

.slot-button.selected {
  border-color: #018c74;

  background: rgba(1, 140, 116, 0.06);
}

.slot-button.selected strong {
  color: #018c74;
}


.payment-section {
  margin: 8px 0 18px;

  border: 1px solid rgba(1, 140, 116, 0.15);

  background: #f5fbfa;

  border-radius: 17px;
}

.payment-header {
  display: flex;

  align-items: center;

  gap: 12px;

  padding: 15px 18px;

  border-bottom: 1px solid rgba(1, 140, 116, 0.1);
}

.payment-icon {
  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background: rgba(1, 140, 116, 0.1);

  color: #018c74;
}

.payment-header strong {
  display: block;

  font-size: 13px;
}

.payment-header span {
  display: block;

  font-size: 11px;

  color: #64748b;
}

.qris-content {
  text-align: center;

  padding: 20px;
}

.qris-img {
  max-width: 240px;

  width: 100%;

  border-radius: 12px;

  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.1);
}

.qris-desc {
  font-size: 12px;

  color: #64748b;

  margin: 10px 0 0;
}

.qris-empty {
  padding: 20px;

  display: flex;
  align-items: center;

  justify-content: center;

  gap: 8px;

  color: #64748b;

  font-size: 12px;
}


.submit-btn {
  border-radius: 13px !important;

  text-transform: none !important;

  font-size: 14px !important;

  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.2) !important;
}


.modern-alert {
  position: relative;
  display: block !important;
  border-radius: 14px !important;
  margin: 0 0 20px !important;
  padding: 14px 16px !important;
  min-height: 52px;

  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08) !important;
}


.alert-content {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
}

.alert-content > span {
  flex: 1;
}


.alert-icon {
  flex: 0 0 auto;
}


.alert-success-custom {
  background: #dcfce7 !important;
  border-left: 5px solid #16a34a !important;
  color: #166534 !important;
}

.alert-success-custom .v-icon {
  color: #16a34a !important;
}

.alert-success-custom .alert-content {
  color: #166534 !important;
}


.alert-error-custom {
  background: #fee2e2 !important;
  border-left: 5px solid #dc2626 !important;
  color: #991b1b !important;
}

.alert-error-custom .v-icon {
  color: #dc2626 !important;
}

.alert-error-custom .alert-content {
  color: #991b1b !important;
}


.alert-warning-custom {
  background: #fef3c7 !important;
  border-left: 5px solid #d97706 !important;
  color: #92400e !important;
}

.alert-warning-custom .v-icon {
  color: #d97706 !important;
}

.alert-warning-custom .alert-content {
  color: #92400e !important;
}


.alert-close {
  flex: 0 0 auto;
  margin-left: 6px;
}

.alert-close .v-icon {
  color: inherit !important;
}


.rekap-heading {
  display: flex;

  align-items: flex-end;

  justify-content: space-between;

  margin-bottom: 20px;
}

.rekap-heading h1 {
  margin: 0 0 4px;

  font-size: 28px;

  font-weight: 800;
}

.rekap-heading p {
  margin: 0;

  color: #64748b;

  font-size: 13px;
}

.refresh-btn {
  border-radius: 11px !important;

  text-transform: none !important;

  color: #018c74 !important;

  background: #ffffff !important;

  border: 1px solid rgba(1, 140, 116, 0.15);
}


.summary-grid {
  display: grid;

  grid-template-columns: repeat(4, 1fr);

  gap: 14px;

  margin-bottom: 18px;
}

.summary-card {
  display: flex;

  align-items: center;

  gap: 13px;

  padding: 18px;

  background: #ffffff;

  border: 1px solid rgba(15, 23, 42, 0.06);

  border-radius: 17px;

  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.04);
}

.summary-icon {
  width: 43px;
  height: 43px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;
}

.summary-card span {
  display: block;

  font-size: 10px;

  color: #94a3b8;

  margin-bottom: 2px;
}

.summary-card strong {
  font-size: 22px;

  line-height: 1;

  color: #1e293b;
}

.summary-card.total .summary-icon {
  color: #6366f1;
  background: #eef2ff;
}

.summary-card.slot .summary-icon {
  color: #f59e0b;
  background: #fffbeb;
}

.summary-card.ai .summary-icon {
  color: #3b82f6;
  background: #eff6ff;
}

.summary-card.pes .summary-icon {
  color: #018c74;
  background: #ecfdf5;
}


.filter-card {
  padding: 18px;

  margin-bottom: 18px;
}

.filter-header {
  display: flex;

  align-items: center;

  justify-content: space-between;

  margin-bottom: 15px;
}

.filter-header strong {
  display: block;

  font-size: 14px;
}

.filter-header span {
  display: block;

  margin-top: 2px;

  font-size: 11px;

  color: #94a3b8;
}

.reset-btn {
  text-transform: none !important;

  color: #64748b !important;
}

.filter-grid {
  display: grid;

  grid-template-columns: 1fr auto;

  gap: 15px;

  align-items: center;
}

.search-field {
  max-width: 550px;
}

.competition-filter {
  display: flex;

  gap: 7px;
}

.filter-chip {
  border: 1px solid #e2e8f0;

  background: #ffffff;

  color: #64748b;

  border-radius: 10px;

  padding: 8px 13px;

  font-size: 11px;

  font-weight: 700;

  cursor: pointer;

  display: flex;

  align-items: center;

  transition: 0.2s;
}

.filter-chip:hover {
  background: #f8fafc;
}

.filter-chip.active {
  background: #018c74;

  color: #ffffff;

  border-color: #018c74;
}

.filter-chip.ai-filter.active {
  background: #3b82f6;

  border-color: #3b82f6;
}

.filter-chip.pes-filter.active {
  background: #018c74;

  border-color: #018c74;
}

.filter-result {
  display: flex;

  align-items: center;

  gap: 10px;

  margin-top: 8px;

  font-size: 11px;

  color: #94a3b8;
}

.filter-result strong {
  color: #334155;
}

.filter-active {
  display: inline-flex;

  align-items: center;

  gap: 3px;

  padding: 3px 8px;

  background: #ecfdf5;

  color: #018c74;

  border-radius: 7px;

  font-weight: 700;
}


.table-card {
}

.table-title {
  padding: 18px 20px;

  border-bottom: 1px solid #f1f5f9;
}

.table-title strong {
  display: block;

  font-size: 14px;
}

.table-title span {
  display: block;

  font-size: 11px;

  color: #94a3b8;

  margin-top: 2px;
}

.modern-table {
  box-shadow: none !important;
}

.modern-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.modern-table >>> table {
  min-width: 850px;
}

.modern-table >>> thead th {
  background: #f8fafc !important;

  color: #64748b !important;

  font-size: 10px !important;

  font-weight: 800 !important;

  text-transform: uppercase;

  letter-spacing: 0.4px;

  border-bottom: 1px solid #e2e8f0 !important;
}

.modern-table >>> tbody tr:hover {
  background: #f8fffd !important;
}

.modern-table >>> tbody td {
  border-bottom: 1px solid #f1f5f9 !important;

  font-size: 12px;
}


.participant {
  display: flex;

  align-items: center;

  gap: 10px;
}

.participant-avatar {
  width: 34px;
  height: 34px;

  flex: 0 0 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background: #e6f7f3;

  color: #018c74;

  font-size: 12px;

  font-weight: 800;
}

.participant strong {
  display: block;

  color: #334155;

  font-size: 12px;
}

.participant span {
  display: block;

  color: #94a3b8;

  font-size: 10px;

  margin-top: 2px;
}


.competition-badge {
  display: inline-flex;

  align-items: center;

  gap: 6px;

  padding: 6px 9px;

  border-radius: 9px;

  font-size: 10px;

  font-weight: 800;
}

.ai-badge {
  background: #eff6ff;

  color: #2563eb;
}

.pes-badge {
  background: #ecfdf5;

  color: #018c74;
}


.phone-number {
  display: flex;

  align-items: center;

  gap: 6px;

  color: #475569;

  font-size: 11px;
}

.phone-number .v-icon {
  color: #22c55e;
}


.slot-badge {
  display: inline-block;

  padding: 5px 9px;

  border-radius: 8px;

  background: #f1f5f9;

  color: #475569;

  font-size: 10px;

  font-weight: 700;
}


.date-cell strong {
  display: block;

  font-size: 11px;

  color: #475569;
}

.date-cell span {
  display: block;

  margin-top: 2px;

  font-size: 10px;

  color: #94a3b8;
}


@media (max-width: 900px) {
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .filter-grid {
    grid-template-columns: 1fr;
  }

  .search-field {
    max-width: none;
  }

  .competition-filter {
    flex-wrap: wrap;
  }
}

@media (max-width: 700px) {
  .esport-container {
    padding: 0 12px;

    margin-top: 18px;
  }

  .navbar-inner {
    padding: 12px;
  }

  .registration-card {
    padding: 20px;
  }

  .form-title {
    font-size: 21px;
  }

  .card-header {
    margin-bottom: 18px;
  }

  .trophy-icon {
    display: none;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-field-full {
    grid-column: span 1;
  }

  .competition-options {
    grid-template-columns: 1fr;
  }

  .summary-grid {
    grid-template-columns: 1fr 1fr;

    gap: 9px;
  }

  .summary-card {
    padding: 13px;

    gap: 9px;
  }

  .summary-icon {
    width: 37px;
    height: 37px;
  }

  .summary-card strong {
    font-size: 18px;
  }

  .summary-card span {
    font-size: 9px;
  }

  .rekap-heading {
    align-items: flex-start;

    gap: 12px;
  }

  .rekap-heading h1 {
    font-size: 23px;
  }

  .refresh-btn {
    min-width: 40px !important;
  }

  .refresh-btn >>> .v-btn__content {
    font-size: 0;
  }

  .refresh-btn >>> .v-icon {
    margin: 0 !important;
  }

  .filter-header {
    align-items: flex-start;
  }

  .tab-button {
    padding: 9px;

    justify-content: center;
  }

  .tab-button small {
    display: none;
  }
}

@media (max-width: 430px) {
  .tab-button strong {
    font-size: 11px;
  }

  .summary-grid {
    grid-template-columns: 1fr;
  }

  .competition-filter {
    width: 100%;
  }

  .filter-chip {
    flex: 1;

    justify-content: center;
  }
}

.captcha-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 78px;
  margin-top: 8px;
  margin-bottom: 25px !important;
}

.bukti-na {
  color: #cbd5e1;
  font-size: 12px;
}

.modern-table >>> table {
  min-width: 1000px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 800;
  border: 1px solid transparent;
}

.status-warning {
  background: #fffbeb;
  color: #d97706;
  border-color: rgba(217, 119, 6, 0.2);
}

.status-success {
  background: #ecfdf5;
  color: #018c74;
  border-color: rgba(1, 140, 116, 0.2);
}

.status-error {
  background: #fef2f2;
  color: #dc2626;
  border-color: rgba(220, 38, 38, 0.2);
}

.esport-page ::v-deep .v-btn,
.esport-page ::v-deep .v-input,
.esport-page ::v-deep .v-input input,
.esport-page ::v-deep .v-label,
.esport-page ::v-deep .v-alert,
.esport-page ::v-deep .v-data-table {
  font-family: "Inter", "Roboto", sans-serif !important;
}

.dokumen-box {
  background: #f4fbf9;
  border: 1px solid rgba(1, 140, 116, 0.12);
  border-radius: 16px;
  padding: 18px 20px;
  margin-bottom: 24px;
}
.dokumen-list {
  margin-top: 8px;
}
.dokumen-kategori {
  font-size: 12px;
  font-weight: 800;
  color: #018c74;
  margin-bottom: 8px;
}
.dokumen-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  margin-bottom: 6px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #334155;
  font-size: 12px;
  text-decoration: none;
}
.dokumen-item:hover {
  border-color: #018c74;
}
.dokumen-item .dokumen-download-icon {
  margin-left: auto;
  color: #018c74;
}

.medsos-box {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.medsos-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}
.medsos-item:hover {
  border-color: #018c74;
  color: #018c74;
}

@media (max-width: 700px) {
  .dokumen-grid {
    grid-template-columns: 1fr;
  }
}

.dokumen-dialog-card {
  border-radius: 18px !important;
  overflow: hidden;
}

.dokumen-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #f1f5f9;
}

.dokumen-dialog-header strong {
  display: block;
  font-size: 14px;
  color: #1e293b;
}

.dokumen-dialog-header span {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.dokumen-dialog-body {
  padding: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  min-height: 300px;
}

.dokumen-full-img {
  max-width: 100%;
  max-height: 65vh;
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.12);
}

.dokumen-pdf-frame {
  width: 100%;
  height: 65vh;
  border: none;
  border-radius: 10px;
  background: #fff;
}

.dokumen-fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 12px;
  padding: 30px;
}

.dokumen-dialog-footer {
  display: flex;
  gap: 10px;
  padding: 14px 18px;
  border-top: 1px solid #f1f5f9;
}

.dokumen-open-link {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px;
  border-radius: 10px;
  border: 1px solid rgba(1, 140, 116, 0.2);
  color: #018c74;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  transition: 0.15s;
}

.dokumen-open-link:hover {
  background: rgba(1, 140, 116, 0.06);
}

.dokumen-open-link.primary {
  background: #018c74;
  color: #ffffff;
  border-color: #018c74;
}

.dokumen-open-link.primary:hover {
  background: #016a5b;
}

.dokumen-item {
  cursor: pointer;
  width: 100%;
  border: 1px solid #e2e8f0;
  background: #fff;
}
</style>
```
